module.exports = __webpack_public_path__ + "img/framework.3f34e061.png";